import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { CnTagCloseable, CnTagGroup, CnTag, CnTooltip, CnIcon, } from '@alife/cn-ui';
import classnames from 'classnames';
import { maxSearchTagsLengthShowLimitInLine, hottagPrefix } from '../const';
import { isFilterValueEmpty, reportHottag } from '../utils';
import QuickFieldForm from './quick-field-form';
const emptyFn = () => { };
const analyzeTypeColor = {
    FILTER: { bg: '#eef5ff', font: '#101E4C' },
    DIMENSION: { bg: '#fff6cf', font: '#5C3E02' },
    METRIC: { bg: '#e6f9f7', font: '#034E48' },
};
function SearchTag({ tags = [], onChange = emptyFn, needExpendShowSearchTags = false, setNeedExpendShowSearchTags = emptyFn, selectedIndex = -1, onTagClick = emptyFn, onTagClose = emptyFn, customShowLimitNum, disabled = false, quickSearchFields = [], fieldRender, }) {
    const realShowLimitNum = customShowLimitNum || maxSearchTagsLengthShowLimitInLine;
    const realNeedExpendShowSearchTags = needExpendShowSearchTags && tags.length > realShowLimitNum;
    const hasMoreTags = tags.length > realShowLimitNum && !needExpendShowSearchTags;
    return Array.isArray(tags) && tags.length > 0 ? (_jsxs(CnTagGroup, { className: classnames('one-search-tag-group', {
            'one-search-tag-group-expend': realNeedExpendShowSearchTags,
            'one-search-tag-group-only-one-tag': tags.length === 1,
        }), children: [tags.map((tag, idx) => {
                const { name, values = [], isFromView = false, entityType, entityKey, analyzeType, labels, } = tag || {};
                let label = null;
                let needDropdown = false;
                let fieldConfig = null;
                let valueStr = '';
                // 兼容之前逻辑并增加RangePickerField类型时使用～渲染
                if (entityType && Array.isArray(labels) && labels.length > 0) {
                    if (entityType === 'RangePickerField' ||
                        entityType === 'RangeDatePickerField') {
                        valueStr = labels.join('~');
                    }
                    else {
                        valueStr = labels.join(',');
                    }
                }
                else {
                    valueStr = values.join(',');
                }
                if (name) {
                    label = (_jsxs("span", { className: 'one-search-tag-box', children: [_jsxs("span", { className: 'one-search-tag-label', style: analyzeType === 'DIMENSION' || analyzeType === 'METRIC'
                                    ? {
                                        color: analyzeTypeColor[analyzeType]?.font,
                                    }
                                    : {}, children: [analyzeType === 'DIMENSION' &&
                                        (entityType === 'DimensionDateMenuField' ||
                                            entityType === 'DimensionTimeMenuField') ? (_jsx(CnIcon, { type: 'triangle-down-fill' })) : null, name, (analyzeType !== 'DIMENSION' && analyzeType !== 'METRIC') ||
                                        (analyzeType === 'DIMENSION' && valueStr)
                                        ? '：'
                                        : ''] }), _jsx("span", { className: 'one-search-tag-value', style: analyzeType === 'FILTER'
                                    ? {
                                        color: analyzeTypeColor[analyzeType]?.font,
                                    }
                                    : {}, children: valueStr })] }));
                    if (entityType && entityKey) {
                        fieldConfig = quickSearchFields.find((field) => field.key === entityKey) || {
                            name,
                            type: entityType,
                            key: entityKey,
                            render: fieldRender,
                        };
                        if (
                        // analyzeType是FILTER、''、null、undefined或（是DIMENSION并且entityType是DimensionDateMenuField或DimensionTimeMenuField）
                        ['DIMENSION', 'METRIC'].indexOf(analyzeType || '') === -1 ||
                            (analyzeType === 'DIMENSION' &&
                                (entityType === 'DimensionDateMenuField' ||
                                    entityType === 'DimensionTimeMenuField'))) {
                            label = (_jsx(CnTooltip, { trigger: label, align: 'b', popupStyle: { maxWidth: '500px' }, children: _jsx("div", { className: classnames({
                                        'one-search-tag-tooltip': analyzeType,
                                    }), children: label }) }));
                            needDropdown = true;
                        }
                    }
                }
                else {
                    label = _jsx("span", { className: 'one-search-tag-value', children: valueStr });
                }
                if (!realNeedExpendShowSearchTags && idx > realShowLimitNum - 1) {
                    return null;
                }
                const key = analyzeType
                    ? `${entityKey}_${analyzeType}`
                    : entityKey || `${valueStr}_${idx}`;
                const tagEl = isFromView ? (_jsx(CnTag, { type: 'normal', children: label })) : (_jsx(CnTagCloseable, { style: analyzeType
                        ? {
                            background: analyzeTypeColor[analyzeType]?.bg,
                            border: 'unset',
                            lineHeight: '24px',
                        }
                        : {}, type: name ? 'normal' : 'primary', onClose: () => {
                        if (disabled) {
                            return false;
                        }
                        onChange(tags.filter((t, i) => i !== idx));
                        reportHottag({
                            hottag: `${hottagPrefix}.searchTag.delete`,
                            name: '搜索标签-鼠标点击删除',
                        });
                        onTagClose(tag);
                        return true;
                    }, onClick: () => {
                        if (disabled) {
                            return;
                        }
                        onTagClick(idx);
                        reportHottag({
                            hottag: `${hottagPrefix}.searchTag.click`,
                            name: '搜索标签-鼠标点击切为编辑态',
                        });
                    }, className: selectedIndex === idx ? 'one-search-tag-selected' : '', children: label }));
                if (needDropdown) {
                    return (_jsx(QuickFieldForm, { disabled: disabled, fieldConfig: fieldConfig, onChange: (newValues, newLabels) => {
                            const newTags = tags.map((t, i) => {
                                if (i === idx) {
                                    return {
                                        ...t,
                                        values: newValues,
                                        labels: newLabels,
                                    };
                                }
                                return t;
                            });
                            onChange(newTags);
                        }, value: { values, labels }, trigger: tagEl, defaultVisible: (analyzeType === 'FILTER' ||
                            typeof analyzeType === 'undefined') &&
                            isFilterValueEmpty(values?.length ? values : labels) &&
                            idx === tags.length - 1 }, entityKey));
                }
                return (_jsx(CnTooltip, { trigger: tagEl, align: 'b', popupStyle: { maxWidth: '500px' }, children: _jsx("div", { className: classnames({
                            'one-search-tag-tooltip': analyzeType,
                        }), children: label }) }, key));
            }), hasMoreTags ? (_jsxs(CnTag, { type: 'normal', className: selectedIndex === realShowLimitNum ? 'one-search-tag-selected' : '', onClick: () => {
                    if (disabled) {
                        return;
                    }
                    setNeedExpendShowSearchTags(true);
                    reportHottag({
                        hottag: `${hottagPrefix}.searchTag.expend`,
                        name: '搜索标签-鼠标点击展开更多',
                    });
                }, children: ["+", tags.length - realShowLimitNum] })) : null] })) : null;
}
SearchTag.displayName = 'OneSearch.SearchTag';
export default React.memo(SearchTag);
